import FactoriaService from '../../services/FactoriaService'

export default {
  namespaced: true,
  state: {
    factorias: [],
    factoria: null,
    totalItems: 0,
    currentPage: 1
  },
  getters: {
    factorias: state => state.factorias,
    factoria: state => state.factoria,
    totalItems: state => state.totalItems,
    currentPage: state => state.currentPage
  },
  mutations: {
    setFactorias(state, factorias) {
      state.factorias = factorias
    },
    setFactoria(state, factoria) {
      state.factoria = factoria
    },
    setTotalItems(state, totalItems) {
      state.totalItems = totalItems
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage
    }
  },
  actions: {
    async fetchFactorias({ commit }, { page = 1, limit = 15, filters = {} }) {
      try {
        const response = await FactoriaService.getFactorias(page, limit, filters)
        commit('setFactorias', response.data.data)
        commit('setTotalItems', response.data.total)
        commit('setCurrentPage', page)
        return response
      } catch (error) {
        console.error('Error fetching factorias:', error)
        throw error
      }
    },
    async fetchAllFactorias({ commit }, filters = {}) {
      try {
        const response = await FactoriaService.getAllFactorias(filters)
        return response
      } catch (error) {
        console.error('Error fetching all factorias:', error)
        throw error
      }
    },
    async fetchFactoria({ commit }, id) {
      try {
        const response = await FactoriaService.getFactoria(id)
        commit('setFactoria', response.data.data)
        return response
      } catch (error) {
        console.error('Error fetching factoria:', error)
        throw error
      }
    },
    async createFactoria({ dispatch }, factoria) {
      try {
        const response = await FactoriaService.createFactoria(factoria)
        return response
      } catch (error) {
        console.error('Error creating factoria:', error)
        throw error
      }
    },
    async updateFactoria({ dispatch }, { id, factoria }) {
      try {
        const response = await FactoriaService.updateFactoria(id, factoria)
        return response
      } catch (error) {
        console.error('Error updating factoria:', error)
        throw error
      }
    },
    async deleteFactoria({ dispatch }, id) {
      try {
        const response = await FactoriaService.deleteFactoria(id)
        return response
      } catch (error) {
        console.error('Error deleting factoria:', error)
        throw error
      }
    }
  }
}